import { arrType, inputTypes, selectOptionsKeyName } from "data/globalData";
import { ZIPPER_PULLER_CATALOGS } from "../ZipperPullerMaster/data";

export const buildPullerSizeCode = (pullerCode, size) =>
	`${String(pullerCode ?? "").trim()} ${String(size ?? "").trim()}`.trim();

export const catalogsNeedingFormOptions = new Set([ZIPPER_PULLER_CATALOGS.PULLER_SIZES]);

export const enrichCatalogFormColumns = (catalog, columns = [], formOptions = {}, mode = "update") => {
	if (catalog !== ZIPPER_PULLER_CATALOGS.PULLER_SIZES) return columns;

	const pullerOptions = (formOptions.pullers ?? []).map((puller) => ({
		key: puller.puller_code,
		name: puller.puller_code,
	}));

	const metalFinishOptions = [
		{ key: "", name: "None" },
		...(formOptions.metal_finishes ?? []).map((finish) => ({
			key: finish.metal_finish_name,
			name: finish.metal_finish_name,
		})),
	];

	return columns.map((column) => {
		if (column.key === "puller_code" && mode === "create") {
			return {
				...column,
				input_type: inputTypes.SELECT.key,
				constraints: { ...column.constraints, NOTNULL: true },
				[selectOptionsKeyName]: { type: arrType, list: pullerOptions },
			};
		}
		if (column.key === "default_metal_finish") {
			return {
				...column,
				input_type: inputTypes.SELECT.key,
				[selectOptionsKeyName]: { type: arrType, list: metalFinishOptions },
			};
		}
		return column;
	});
};
